import Vue from 'vue';

import UiBreadcrumb from '@/components/ui/ui-breadcrumb';
import UiPagination from '@/components/ui/ui-pagination';
import UiEmpty from '@/components/ui/ui-empty';

import ViewLayout from '@/components/view-layout/index';
import ViewList from '@/components/view-layout/view-list';
import ViewArticle from '@/components/view-layout/view-article';
import ViewDetail from '@/components/view-layout/view-detail';

Vue.component('UiBreadcrumb', UiBreadcrumb);
Vue.component('UiPagination', UiPagination);
Vue.component('UiEmpty', UiEmpty);

Vue.component('ViewList', ViewList);
Vue.component('ViewLayout', ViewLayout);
Vue.component('ViewArticle', ViewArticle);
Vue.component('ViewDetail', ViewDetail);